import animateScrollTo from 'animated-scroll-to';
import { useEffect } from 'react';
import { useGetParams } from './useGetParams';

export const useScrollText = (
  contentRef,
  contentContainerRef,
  message,
  setDelay,
  messagesWrapper,
  isCurrent
) => {
  const { scrollSpeed, scrollDelayStart, scrollDelayEnd, duration } =
    useGetParams();

  useEffect(() => {
    if (!contentRef.current || !contentContainerRef.current || !isCurrent)
      return;
    if (
      contentRef.current.getBoundingClientRect().height -
        contentContainerRef.current.getBoundingClientRect().height >=
      10
    ) {
      // флаг - прошла анимация появления контейнера с сообщением (увеличение размера от 0,9 до 1)
      const isDoneAnimationMsg = messagesWrapper
        ? messagesWrapper.classList.contains('fade-scale-enter-done')
        : false;

      // если анимация не прошла, нужно учесть размер 0,9(анимация появления) для правильной высоты контента
      // высота всего контента
      const height =
        contentRef.current.getBoundingClientRect().height /
        (isDoneAnimationMsg ? 1 : 0.9);

      const elementToScroll = contentContainerRef.current;

      // lineHeightInit - высота контейнера в котором идет прокрутка, остаются видимы 3 строки после прокрутки текста
      const lineHeightInit =
        elementToScroll.getBoundingClientRect().height /
        (isDoneAnimationMsg ? 1 : 0.9);

      // скорость скрола в пикселей/милисекунда
      const speedPxPerMs = scrollSpeed / 1000;

      // длительность прокрутки
      const linearAnimationDuration = Math.ceil(
        (height - lineHeightInit) / speedPxPerMs
      );
      // задержка перед сменой сообщения
      const delayInterval =
        scrollDelayStart + linearAnimationDuration + scrollDelayEnd;

      setDelay(delayInterval);

      setTimeout(() => {
        animateScrollTo([0, height], {
          elementToScroll,
          minDuration: linearAnimationDuration,
          maxDuration: linearAnimationDuration,
          easing: (t) => {
            return t;
          },
        });
      }, scrollDelayStart);
    } else {
      // если не нужна прокрутка, дефолтная длительность показа сообщения
      setDelay(duration);
    }
  }, [
    message,
    scrollSpeed,
    duration,
    contentRef,
    contentContainerRef,
    //
    scrollDelayStart,
    scrollDelayEnd,
    setDelay,
    messagesWrapper,
    isCurrent,
  ]);
};
